export const fmtTRY = (n) => {
  const val = Number(n || 0);
  return new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val) + " ₺";
};

export const fmtNum = (n) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 }).format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const VAT_RATES = [0, 1, 10, 20];
